import React, { useState } from 'react';
import { Trash2, Plus } from 'lucide-react';

export default function SocialLinksField({ data, setData, socialPlatforms }) {
  const [newPlatform, setNewPlatform] = useState('');
  const [newUrl, setNewUrl] = useState('');

  const addLink = () => {
    if (!newPlatform || !newUrl.trim()) return;
    const newLink = { platform: newPlatform, url: newUrl.trim() };
    setData('social_links', [...data.social_links, newLink]);
    setNewPlatform('');
    setNewUrl('');
  };

  const removeLink = (index) => {
    const updated = [...data.social_links];
    updated.splice(index, 1);
    setData('social_links', updated);
  };

  return (
    <div className="col-12">
      <label className="form-label fw-semibold">Social Links</label>

      {data.social_links.length > 0 && (
        <div className="mb-3">
          {data.social_links.map((link, idx) => (
            <div key={idx} className="d-flex align-items-center mb-2 p-2 bg-light rounded">
              <div className="me-2" style={{ minWidth: '100px' }}>
                <span className="badge bg-secondary">
                  {socialPlatforms[link.platform]?.label || 'Custom'}
                </span>
              </div>
              <div className="flex-grow-1 me-2">
                <code className="text-muted small">
                  {socialPlatforms[link.platform]?.prefix}{link.url}
                </code>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => removeLink(idx)}
                title="Remove link"
              >
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add new link form */}
      <div className="border rounded p-3 bg-body-tertiary">
        <div className="row g-2">
          <div className="col-md-4">
            <select
              className="form-select form-select-sm"
              value={newPlatform}
              onChange={(e) => setNewPlatform(e.target.value)}
            >
              <option value="" disabled>Choose platform...</option>
              {Object.entries(socialPlatforms).map(([key, val]) => (
                <option key={key} value={key}>
                  {val.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="username or path"
              value={newUrl}
              onChange={(e) => setNewUrl(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button
              type="button"
              className="btn btn-primary btn-sm w-100"
              onClick={addLink}
              disabled={!newPlatform || !newUrl.trim()}
            >
              <Plus size={14} className="me-1" /> Add
            </button>
          </div>
        </div>
      </div>

      <small className="text-muted d-block mt-2">
        Add your social media profiles and website links
      </small>
    </div>
  );
}
